var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCa5A7Ffc2F89E05A3B1Bea144157F7Be115142Ac4F72D107A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_956_8595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14C17.6887 14 19.8818 16.1223 19.9954 18.7831L20 19V20C20 21.0544 19.1841 21.9182 18.1493 21.9945L18 22H4C2.94564 22 2.08183 21.1841 2.00549 20.1493L2 20V19C2 16.3113 4.12231 14.1182 6.78311 14.0046L7 14H15ZM21 13C21.5523 13 22 13.4477 22 14C22 14.5523 21.5523 15 21 15H20C19.4477 15 19 14.5523 19 14C19 13.4477 19.4477 13 20 13H21ZM11 2C13.7614 2 16 4.23858 16 7C16 9.76142 13.7614 12 11 12C8.23858 12 6 9.76142 6 7C6 4.23858 8.23858 2 11 2ZM21 10C21.5523 10 22 10.4477 22 11C22 11.5523 21.5523 12 21 12H19C18.4477 12 18 11.5523 18 11C18 10.4477 18.4477 10 19 10H21ZM21 7C21.5523 7 22 7.44772 22 8C22 8.51283 21.614 8.93551 21.1166 8.99327L21 9H18C17.4477 9 17 8.55228 17 8C17 7.48717 17.386 7.06449 17.8834 7.00673L18 7H21Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_956_8595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa5A7Ffc2F89E05A3B1Bea144157F7Be115142Ac4F72D107A);
export default __webpack_public_path__ + "static/media/ca5a7ffc2f89e05a3b1bea144157f7be115142ac4f72d107a.4a0c0f5a84ff00afee803abdd73fb0e2.svg";
export { ForwardRef as ReactComponent };